import axios from 'axios';

import { ConsumeAccessLinkResponse } from './types';

export const consumeAccessLink = async (chave: string, colaboradorToken: string) => {
  const response = await axios.post<ConsumeAccessLinkResponse>(
    `${process.env.REACT_APP_PORTAL_ACESSO_URL}/link-acesso/consumir`,
    { chave },
    { headers: { Authorization: `Bearer ${colaboradorToken}` } },
  );
  return response.data;
};
